var map = {
	"./black-closed-toe-shoes.jpg": "./src/assets/img/uniforms/black-closed-toe-shoes.jpg",
	"./black-jeans.jpg": "./src/assets/img/uniforms/black-jeans.jpg",
	"./black-polo-shirt.jpg": "./src/assets/img/uniforms/black-polo-shirt.jpg",
	"./black-shirt-casual.jpg": "./src/assets/img/uniforms/black-shirt-casual.jpg",
	"./black-shirt-formal.jpg": "./src/assets/img/uniforms/black-shirt-formal.jpg",
	"./black-t-shirt.jpg": "./src/assets/img/uniforms/black-t-shirt.jpg",
	"./black-tie.jpg": "./src/assets/img/uniforms/black-tie.jpg",
	"./black-trainersflats.jpg": "./src/assets/img/uniforms/black-trainersflats.jpg",
	"./black-trousers-formal.jpg": "./src/assets/img/uniforms/black-trousers-formal.jpg",
	"./blazer.jpg": "./src/assets/img/uniforms/blazer.jpg",
	"./blue-jeans.jpg": "./src/assets/img/uniforms/blue-jeans.jpg",
	"./chefs-whites.jpg": "./src/assets/img/uniforms/chefs-whites.jpg",
	"./closed-toe-crocs-or-chef-shoes.jpg": "./src/assets/img/uniforms/closed-toe-crocs-or-chef-shoes.jpg",
	"./gloves.jpg": "./src/assets/img/uniforms/gloves.jpg",
	"./grey-t-shirt.jpg": "./src/assets/img/uniforms/grey-t-shirt.jpg",
	"./high-vis-vest.jpg": "./src/assets/img/uniforms/high-vis-vest.jpg",
	"./kitchen-trousers.jpg": "./src/assets/img/uniforms/kitchen-trousers.jpg",
	"./other.jpg": "./src/assets/img/uniforms/other.jpg",
	"./protective-shirt.jpg": "./src/assets/img/uniforms/protective-shirt.jpg",
	"./protective-shoes.jpg": "./src/assets/img/uniforms/protective-shoes.jpg",
	"./protective-trousers.jpg": "./src/assets/img/uniforms/protective-trousers.jpg",
	"./steel-toe-capped-boots.jpg": "./src/assets/img/uniforms/steel-toe-capped-boots.jpg",
	"./white-shirt-casual.jpg": "./src/assets/img/uniforms/white-shirt-casual.jpg",
	"./white-shirt-formal.jpg": "./src/assets/img/uniforms/white-shirt-formal.jpg",
	"./white-shirtblack-waistcoat-tie.jpg": "./src/assets/img/uniforms/white-shirtblack-waistcoat-tie.jpg",
	"./white-t-shirt.jpg": "./src/assets/img/uniforms/white-t-shirt.jpg",
	"./white-trainersflats.jpg": "./src/assets/img/uniforms/white-trainersflats.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/uniforms sync recursive ^\\.\\/.*\\.jpg$";